var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMutation } from '@tanstack/react-query';
import { accountSummaryV2CacheKey, profileDetailsCacheKey } from 'syf-api';
import queryClient from '../../const/query-client';
import ENDPOINTS from '../../const/endpoints';
import { fetchConfig } from '../../helpers';
import { accountCreditLimitChangeCacheKey } from './account-credit-limit-change-key';
function useAccountCreditLimitChange(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.mutationOptions, mutationOptions = _b === void 0 ? {} : _b;
    var fetchWrapper = fetchConfig(config);
    var accountId = keyProps.accountId, requestedLimit = keyProps.requestedLimit, income = keyProps.income, promoStrategyCode = keyProps.promoStrategyCode, merchantNumber = keyProps.merchantNumber;
    return useMutation(__assign({ mutationKey: accountCreditLimitChangeCacheKey(keyProps), mutationFn: function () {
            return fetchWrapper(ENDPOINTS.creditLimitChange, {
                method: 'PUT',
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: 'guid',
                    requestedLimit: requestedLimit,
                    income: income,
                    promoStrategyCode: promoStrategyCode,
                    merchantNumber: merchantNumber
                })
            });
        }, onSuccess: function () {
            var accountIdType = keyProps === null || keyProps === void 0 ? void 0 : keyProps.accountIdType;
            // Invalidating account summary
            queryClient.invalidateQueries(accountSummaryV2CacheKey({
                accountId: accountId,
                accountIdType: accountIdType
            }));
            // Invalidating Profile
            queryClient.invalidateQueries(profileDetailsCacheKey({
                accountId: accountId,
                accountIdType: accountIdType
            }));
        } }, mutationOptions));
}
export default useAccountCreditLimitChange;
